import { Injectable } from '@angular/core';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { BehaviorSubject, Subject } from 'rxjs';
import { AssignmentGroupConstants } from '../assignment-group-constants';

@Injectable({
  providedIn: 'root'
})
export class AssignmentGroupInteractionService {

  
  constructor(private confirmationService: ConfirmationService) { 
  }

  updatePanelList$ =new BehaviorSubject<boolean>(false);
  //Below code is used to store eQMS List and to use it across the module
  private eQMSscopeSubject = new BehaviorSubject<any[]>([]);
  
  //Below code is used to store selected scope
  private selectedeQMSScopeSubject = new BehaviorSubject<any>('');

  public get geteQMSSelectedScope$() {
    return this.selectedeQMSScopeSubject.asObservable();
  }

  public set seteQMSScope(value: any) {
    this.selectedeQMSScopeSubject.next(value);
  }

  updatePanelListOnCreateOrEdit = () =>{
    this.updatePanelList$.next(true);
  }
  //Below code is to close the slider by updating a value 
  closeAndResetAssignmentGroupSlider$ = new BehaviorSubject<boolean>(false);

  openConfirmationDialog = () => {
    this.confirmationService.confirm({
      message:  AssignmentGroupConstants.AssignmentGroup_Slider_Confirmation_Text,
      header: AssignmentGroupConstants.AssignmentGroup_Slider_Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetAssignmentGroupSlider$.next(true);
      },
    });
}

}

